<h2 mat-dialog-title translate>ecommerceDialog.title</h2>
<mat-dialog-content>
  <mat-grid-list cols="16" rowHeight="60px">
    <mat-grid-tile colspan="16" rowspan="1">
      <mat-label fxFlex class="detailEcommerce__title" translate>ecommerceDialog.data</mat-label>
    </mat-grid-tile>
    <mat-grid-tile colspan="8" rowspan="1">
      <div class="detail__field">
        <mat-label class="title__field" translate>ecommerceDialog.IdCommerce</mat-label>
        <mat-label class="data__field">{{ ecommerceReportDetailDTO.idEcommerce }}</mat-label>
      </div>
    </mat-grid-tile>
    <mat-grid-tile colspan="8" rowspan="1">
      <div class="detail__field">
        <mat-label class="title__field" translate>ecommerceDialog.guidOpEcommerce</mat-label>
        <mat-label class="data__field">{{ ecommerceReportDetailDTO.guid }}</mat-label>
      </div>
    </mat-grid-tile>
    <mat-grid-tile colspan="16" rowspan="1">
      <mat-label fxFlex class="detailEcommerce__title" translate>ecommerceDialog.scoring</mat-label>
    </mat-grid-tile>
    <mat-grid-tile colspan="4" rowspan="1">
      <div class="detail__field">
        <mat-label class="title__field" translate>ecommerceDialog.numRequest</mat-label>
        <mat-label class="data__field">{{ ecommerceReportDetailDTO.numOperacion }}</mat-label>
      </div>
    </mat-grid-tile>
    <mat-grid-tile colspan="4" rowspan="1">
      <div class="detail__field">
        <mat-label class="title__field" translate>ecommerceDialog.statusScoring</mat-label>
        <mat-label class="data__field">{{ ecommerceReportDetailDTO.codStateScoring }}</mat-label>
      </div>
    </mat-grid-tile>
    <mat-grid-tile colspan="4" rowspan="1">
      <div class="detail__field">
        <mat-label class="title__field" translate>ecommerceDialog.messageScoring</mat-label>
        <mat-label class="data__field">{{ ecommerceReportDetailDTO.msgStateScoring }}</mat-label>
      </div>
    </mat-grid-tile>
    <mat-grid-tile colspan="4" rowspan="1">
      <div class="detail__field">
        <mat-label class="title__field" translate>ecommerceDialog.dateScoring</mat-label>
        <mat-label class="data__field">{{ ecommerceReportDetailDTO.dateScoring | date: 'short' }}</mat-label>
      </div>
    </mat-grid-tile>
    <mat-grid-tile colspan="16" rowspan="1">
      <mat-label fxFlex class="detailEcommerce__title" translate>ecommerceDialog.tpv</mat-label>
    </mat-grid-tile>
    <mat-grid-tile colspan="5" rowspan="1">
      <div class="detail__field">
        <mat-label class="title__field" translate>ecommerceDialog.statusTpv</mat-label>
        <mat-label class="data__field">{{ ecommerceReportDetailDTO.codStateTpv }}</mat-label>
      </div>
    </mat-grid-tile>
    <mat-grid-tile colspan="5" rowspan="1">
      <div class="detail__field">
        <mat-label class="title__field" translate>ecommerceDialog.messageTpv</mat-label>
        <mat-label class="data__field">{{ ecommerceReportDetailDTO.msgTpv }}</mat-label>
      </div>
    </mat-grid-tile>
    <mat-grid-tile colspan="5" rowspan="1">
      <div class="detail__field">
        <mat-label class="title__field" translate>ecommerceDialog.dateTpv</mat-label>
        <mat-label class="data__field">{{ ecommerceReportDetailDTO.dateTpv | date: 'short' }}</mat-label>
      </div>
    </mat-grid-tile>
    <mat-grid-tile colspan="16" rowspan="1">
      <mat-label fxFlex class="detailEcommerce__title" translate>ecommerceDialog.process</mat-label>
    </mat-grid-tile>
    <mat-grid-tile colspan="5" rowspan="1">
      <div class="detail__field">
        <mat-label class="title__field" translate>ecommerceDialog.dateProcess</mat-label>
        <mat-label class="data__field">{{ ecommerceReportDetailDTO.dateProcess | date: 'short' }}</mat-label>
      </div>
    </mat-grid-tile>
    <mat-grid-tile colspan="5" rowspan="1">
      <div class="detail__field">
        <mat-label class="title__field" translate>ecommerceDialog.codeEcommerce</mat-label>
        <mat-label class="data__field">{{ ecommerceReportDetailDTO.codFinalEcommerce }}</mat-label>
      </div>
    </mat-grid-tile>
    <mat-grid-tile colspan="5" rowspan="1">
      <div class="detail__field">
        <mat-label class="title__field" translate>ecommerceDialog.descriptionEcommerce</mat-label>
        <mat-label class="data__field">{{ ecommerceReportDetailDTO.descFinalEcommerce }}</mat-label>
      </div>
    </mat-grid-tile>
    <mat-grid-tile colspan="16" rowspan="1">
      <mat-label fxFlex class="detailEcommerce__title" translate>ecommerceDialog.holder</mat-label>
    </mat-grid-tile>
    <mat-grid-tile colspan="6" rowspan="1">
      <div class="detail__field">
        <mat-label class="title__field" translate>ecommerceDialog.address</mat-label>
        <mat-label class="data__field">{{ ecommerceReportDetailDTO.nameAddress }}</mat-label>
      </div>
    </mat-grid-tile>
    <mat-grid-tile colspan="2" rowspan="1">
      <div class="detail__field">
        <mat-label class="title__field" translate>ecommerceDialog.number</mat-label>
        <mat-label class="data__field">{{ ecommerceReportDetailDTO.numAddress }}</mat-label>
      </div>
    </mat-grid-tile>
    <mat-grid-tile colspan="3" rowspan="1">
      <div class="detail__field">
        <mat-label class="title__field" translate>ecommerceDialog.complementAddress</mat-label>
        <mat-label class="data__field">{{ ecommerceReportDetailDTO.stair }}</mat-label>
      </div>
    </mat-grid-tile>
    <mat-grid-tile colspan="2" rowspan="1">
      <div class="detail__field">
        <mat-label class="title__field" translate>ecommerceDialog.floor</mat-label>
        <mat-label class="data__field">{{ ecommerceReportDetailDTO.floor }}</mat-label>
      </div>
    </mat-grid-tile>
    <mat-grid-tile colspan="2" rowspan="1">
      <div class="detail__field">
        <mat-label class="title__field" translate>ecommerceDialog.door</mat-label>
        <mat-label class="data__field">{{ ecommerceReportDetailDTO.door }}</mat-label>
      </div>
    </mat-grid-tile>
    <mat-grid-tile colspan="8" rowspan="1">
      <div class="detail__field">
        <mat-label class="title__field" translate>ecommerceDialog.postalCode</mat-label>
        <mat-label class="data__field">{{ ecommerceReportDetailDTO.postalCode }}</mat-label>
      </div>
    </mat-grid-tile>
    <mat-grid-tile colspan="8" rowspan="1">
      <div class="detail__field">
        <mat-label class="title__field" translate>ecommerceDialog.population</mat-label>
        <mat-label class="data__field">{{ ecommerceReportDetailDTO.population }}</mat-label>
      </div>
    </mat-grid-tile>
    <mat-grid-tile colspan="8" rowspan="1">
      <div class="detail__field">
        <mat-label class="title__field" translate>ecommerceDialog.telephone</mat-label>
        <mat-label class="data__field">{{ ecommerceReportDetailDTO.mobilePhone }}</mat-label>
      </div>
    </mat-grid-tile>
    <mat-grid-tile colspan="8" rowspan="1">
      <div class="detail__field">
        <mat-label class="title__field" translate>ecommerceDialog.additionalPhone</mat-label>
        <mat-label class="data__field">{{ ecommerceReportDetailDTO.phone }}</mat-label>
      </div>
    </mat-grid-tile>
    <mat-grid-tile colspan="8" rowspan="1">
      <div class="detail__field">
        <mat-label class="title__field" translate>ecommerceDialog.email</mat-label>
        <mat-label class="data__field">{{ ecommerceReportDetailDTO.email }}</mat-label>
      </div>
    </mat-grid-tile>
    <mat-grid-tile colspan="8" rowspan="1">
      <div class="detail__field">
        <mat-label class="title__field" translate>ecommerceDialog.language</mat-label>
        <mat-label class="data__field">{{ ecommerceReportDetailDTO.language }}</mat-label>
      </div>
    </mat-grid-tile>
    <mat-grid-tile colspan="16" rowspan="1">
      <mat-label fxFlex class="detailEcommerce__title" translate>ecommerceDialog.consents</mat-label>
    </mat-grid-tile>
    <mat-grid-tile colspan="16" rowspan="1">
      <mat-checkbox fxFlex disabled [checked]="ecommerceReportDetailDTO.consentsDTO.check_TDPFCFRSC === 'S'">
        <mat-label translate>ecommerceDialog.consentSabadell</mat-label>
      </mat-checkbox>
    </mat-grid-tile>
    <mat-grid-tile colspan="16" rowspan="1">
      <mat-checkbox fxFlex disabled [checked]="ecommerceReportDetailDTO.consentsDTO.check_CDPFC === 'S'">
        <mat-label translate>ecommerceDialog.consentPersonalCommercial</mat-label>
      </mat-checkbox>
    </mat-grid-tile>
    <mat-grid-tile colspan="16" rowspan="1">
      <mat-checkbox fxFlex disabled [checked]="ecommerceReportDetailDTO.consentsDTO.check_TDPFC === 'S'">
        <mat-label translate>ecommerceDialog.consentCommercial</mat-label>
      </mat-checkbox>
    </mat-grid-tile>
    <mat-grid-tile colspan="16" rowspan="1">
      <mat-checkbox fxFlex disabled [checked]="ecommerceReportDetailDTO.consentsDTO.check_CBPDDEBP === 'S'">
        <mat-label translate>ecommerceDialog.consentBonPreu</mat-label>
      </mat-checkbox>
    </mat-grid-tile>
    <mat-grid-tile colspan="16" rowspan="1">
      <mat-checkbox fxFlex disabled [checked]="ecommerceReportDetailDTO.consentsDTO.check_TDTGSS === 'S'">
        <mat-label translate>ecommerceDialog.consentTgss</mat-label>
      </mat-checkbox>
    </mat-grid-tile>
  </mat-grid-list>
</mat-dialog-content>
